<div
  class="chips-cell"
  (click)="onClickShowMore()"
  [ngClass]="{ open: showMore() }"
  [class.chips-cell-compact-mode]="isCompactModeActivated()"
>
  <div class="example-chip-list">
    <mat-chip-grid #chipList [attr.aria-label]="ariaLabel()">
      <div class="display-block" [ngClass]="{ open: showMore() }">
        @for (item of displayItems(); let i = $index; track item.id) {
          @if (showMore() || i < 1) {
            <mat-chip-row
              class="example-chip-list__chip"
              [matTooltip]="item.label !== item.tooltip ? item.tooltip : null"
              (removed)="onRemove(item)"
              (click)="onChipClick(item)"
            >
              {{ item.label }}
              @if (showMore() && canEdit()) {
                <button matChipRemove>
                  <mat-icon class="example-chip-list__delete">cancel</mat-icon>
                </button>
              }
            </mat-chip-row>
          }
        }
        @if (!showMore() && displayItems().length > 1) {
          <mat-chip-row class="example-chip-list__chip" [matTooltip]="overflowTooltip()">
            +{{ displayItems().length - 1 }}
          </mat-chip-row>
        }
      </div>
      <div class="example-chip-list__input-container">
        <input
          class="example-chip-list__input"
          [ngClass]="{ hidden: !showMore() || !canEdit() }"
          #chipsInput
          [placeholder]="placeholder()"
          [formControl]="ctrl"
          [matAutocomplete]="auto"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          (matChipInputTokenEnd)="onAdd($event)"
          (keyup)="onKeyUp($event)"
        />
        @if (showMore() && canEdit() && showAddButton()) {
          <button
            class="chips-cell__button"
            mat-icon-button
            (click)="onAddButton()"
            [disabled]="addButtonDisabled()"
            matTooltip="Add"
          >
            <mat-icon>add_box</mat-icon>
          </button>
        }
      </div>
    </mat-chip-grid>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelected($event)">
      @for (option of filteredOptions(); track option.value) {
        <mat-option [value]="option.value">
          {{ option.label }}
        </mat-option>
      }
    </mat-autocomplete>
  </div>
  @if (showMore()) {
    <button
      mat-icon-button
      class="chips-cell__show-less"
      matTooltip="Close"
      (click)="onClickShowLess($event)"
    >
      <mat-icon>close</mat-icon>
    </button>
  }
</div>
